// extracted by mini-css-extract-plugin
export default {"bgWrap":"FAQ_bgWrap__I5Ndw","titleBox":"FAQ_titleBox__yr-OM","collapse":"FAQ_collapse__28-Cs","tabs":"FAQ_tabs__Qc2zX","contactSection":"FAQ_contactSection__0ySRX"};